import { render, staticRenderFns } from "./last_entry_canada.vue?vue&type=template&id=2e3d7952&"
import script from "./last_entry_canada.vue?vue&type=script&lang=js&"
export * from "./last_entry_canada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports